var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8D8599",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.841.167V7.17h17.692V.167H.841Zm16.218 5.53H2.316V1.641h14.743v4.054ZM2.316 7.908h-.737v1.105h.737V7.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.316 7.908h-.737v1.105h.737V7.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.476 7.908v9.951H.84V7.908h.737v1.105h.738v7.74H6v-7.74h.738V7.908h.737Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.739 7.908H6v1.105h.738V7.908ZM8.213 7.908v9.951h10.32V7.908H8.213Zm1.474 8.477V9.382h7.372v7.003H9.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.739 7.908h-5.16v1.105h5.16V7.908Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v17.78H0z",
    transform: "translate(.749 .11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6b1a26c5.svg";
export { ForwardRef as ReactComponent };